// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"347":"c97a9f50","490":"13e4577e","871":"aee35910"}[chunkId] + ".css";
};